"use strict";
/**
 * Created by Pankaj on 2020/01/02.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helper = void 0;
const PromoPanelConfig_1 = require("../config/PromoPanelConfig");
const NolimitPromotionPlugin_1 = require("../NolimitPromotionPlugin");
class Helper {
    static translate(string) {
        return NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(string);
    }
    static unique(a) {
        return Array.from(new Set(a));
    }
    static shrinkTextWidth(text, textContainer, maxWidth) {
        while (textContainer.width > maxWidth) {
            if (this.isString(textContainer.style.fontSize)) {
                if (textContainer.style.fontSize.indexOf("em") > -1) {
                    debugger;
                    throw new Error("Helper.shrinkTextWidth(), I am lazy so I don't want to parse em, please use number or px.");
                }
                textContainer.style.fontSize = parseInt(textContainer.style.fontSize);
            }
            textContainer.style.fontSize--;
            if (textContainer.style.fontSize <= 10) {
                textContainer.style.fontSize = 10;
                return;
            }
        }
    }
    static isDefaultScreenRatio(bounds) {
        const max = Math.max(bounds.width, bounds.height);
        const min = Math.min(bounds.width, bounds.height);
        return (max / min) > PromoPanelConfig_1.PromoPanelConfig.DEFAULT_SCREEN_MIN_RATIO;
    }
    static isIphoneScreenRatio(bounds) {
        const max = Math.max(bounds.width, bounds.height);
        const min = Math.min(bounds.width, bounds.height);
        return (max / min) > PromoPanelConfig_1.PromoPanelConfig.DEFAULT_SCREEN_MIN_RATIO;
    }
    static padZero(value) {
        return value.toString().padStart(2, "0");
    }
    static floorPos(value) {
        return Math.floor(value);
    }
    static getMaxFromArray(arr) {
        let max = Number.MIN_VALUE;
        for (let i = 0; i < arr.length; i++) {
            max = Math.max(max, +arr[i]);
        }
        return max;
    }
    static getTotalMultipliedWin(accumulatedRoundWin, playedBetValue) {
        const decimalCutOffMultiplier = Math.pow(10, PromoPanelConfig_1.PromoPanelConfig.DECIMAL_CUTOFF - 1);
        return (accumulatedRoundWin * decimalCutOffMultiplier) / (playedBetValue * decimalCutOffMultiplier);
    }
    static formatCost(val) {
        if (this.countDecimals(val) < 2) {
            return val.toFixed(2);
        }
        return val.toString();
    }
    static isString(object) {
        return typeof object == "string";
    }
    static ceilToDecimals(value, decimals) {
        return Math.ceil(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }
}
Helper.countDecimals = function (value) {
    if (Math.floor(value) === value) {
        return 0;
    }
    else {
        return value.toString().split(".")[1].length || 0;
    }
};
exports.Helper = Helper;
//# sourceMappingURL=Helper.js.map